// Makes requests to CryptoCompare API
export async function makeApiRequest(path) {
  try {
    const response = await fetch(`${window.env.APING_URL}/insights${path}&apikey=${window.env.VUE_APP_TOKEN}`);
    return response.json();
  } catch (error) {
    throw new Error(`Insights request error: ${error.status}`);
  }
}
